export const layout = {
  brand: {
    logoAlt: 'SkillArea',
  },
  nav: {
    games: 'Games',
    privacy: 'Privacy Policy',
    terms: 'Terms of Use',
  },
  footer: {
    disclaimer:
      'Our games, tournaments, and competitions are skill-based, do not incorporate gambling mechanics, and therefore are not classified as gambling.',
    sendEmail: 'Send email',
    companyName: 'Quantum LLC',
    companyAddress:
      "Georgia, Tbilisi, Nadzaladevi district, Zghvisubani settlement, XI micro/district, II quarter, building 38', apartment 7",
  },
  accountPage: {
    title: 'Profile',
    subtitle: 'View all your profile details here',
  },
  header: {
    logout: 'Log out',
    aria: {
      loadingBalance: 'Loading balance',
      logout: 'Log out',
      menu: 'Menu',
      closeMenu: 'Close menu',
      closeOverlay: 'Close menu overlay',
    },
    alt: {
      games: 'Games',
      balance: 'Balance',
      login: 'Log in',
    },
  },
  accountMenu: {
    editProfile: 'Edit profile',
    balance: 'Balance',
    promocode: 'Promo code',
    achievements: 'Achievements',
    gameHistory: 'Game history',
  },
  language: {
    ariaLabel: 'Language',
    en: 'English',
    ka: 'Georgian',
  },
};
